__turbopack_context__.v({
  "logoPanel": "Branding-module__pft-6a__logoPanel",
  "stage": "Branding-module__pft-6a__stage",
});
